<template>
  <div class="bg-base-100 p-6 rounded-xl shadow-lg transition-transform duration-300 hover:scale-105">
    <!-- Context Badge -->
    <div v-if="testimonial.context" class="mb-4">
      <span class="inline-block bg-success/20 text-success px-3 py-1 rounded-full text-xs font-semibold">
        {{ testimonial.context }}
      </span>
    </div>
    
    <p class="italic text-base-content/80">"{{ testimonial.quote }}"</p>
    <div class="mt-4 text-sm text-base-content/70 text-center">
      <strong>{{ testimonial.author }}</strong>
      <div v-if="testimonial.logo" class="mt-2">
        <img :src="testimonial.logo" :alt="testimonial.author + ' logo'" class="w-16 h-auto mx-auto" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

interface Testimonial {
  quote: string;
  author: string;
  logo?: string | null;
  context?: string;
}

const props = defineProps<{ testimonial: Testimonial }>();
</script>
